import { net, offer } from "../store.js";

/** Bottom-center situational prompt: downed / reviving ally / co-op level-up pause. */
export function Prompts() {
  const n = net.value;
  if (n === null) return null;
  let text: string | null = null;
  if (n.downed)
    text = `You are downed — a teammate can revive you (${Math.round(n.reviveProgress * 100)}%)`;
  else if (n.nearDownedAlly) text = "Reviving ally — stay close…";
  else if (n.paused && offer.value === null) text = "Paused — a teammate is choosing an upgrade…";
  if (text === null) return null;
  return (
    <div class="absolute bottom-44 left-1/2 -translate-x-1/2 rounded-lg bg-panel/85 px-3.5 py-1.5 text-sm">
      {text}
    </div>
  );
}
